<template>
  <div>
    <Head :title="title" />
    <div v-if="type.deleted_at" class="mb-6 bg-red-100 border border-red-200 text-red-800 rounded-md px-4 py-3 flex items-center justify-between">
      <span>{{ __('This category has been deleted.') }}</span>
      <button class="text-red-800 font-bold hover:underline" type="button" @click="restore">{{ __('Restore') }}</button>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full" :label="__('Name')" is_required />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!type.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
            {{ __('Delete Category') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update Category') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    type: Object,
    title: String,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.type.name,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(this.route('types.update', this.type.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this category?')) {
        this.$inertia.delete(this.route('types.destroy', this.type.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this category?')) {
        this.$inertia.put(this.route('types.restore', this.type.id))
      }
    },
  },
}
</script>
